import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

interface LogoutButtonProps {
    onLogout: () => Promise<void>;
}

export const LogoutButton = ({ onLogout }: LogoutButtonProps) => (
    <Button
        variant="link"
        size="icon"
        onClick={onLogout}
        className="h-8 w-8 text-stone-900 hover:text-orange-500"
        title="Log out"
    >
        <LogOut className="h-4 w-4" />
    </Button>
);

export default LogoutButton;